export const CountryComponent = (props) => {
    const text = props.searchValue;
    return (
        <div>
            {text}
        </div>
    )
}
